export default "__VITE_ASSET__DdbYFKtk__"